<template>
    <div class="report-widget-resources"
         v-if="planResources && planResources.length">

        <div class="text-left">
            <label>{{ $i18n.gt('LABEL_RESOURCES') }}</label>

            <div v-for="(opt,i) in planOptions" :key="i">
                <b-form-checkbox v-model="opt.checked">
                    {{ opt.value }}
                </b-form-checkbox>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import * as _ from 'lodash'

    /**
     * Displays a list of checkboxes to select Resources for an individual ReportWidget.
     * Changing a selection triggers autosave of the SurveyNote (see SurveyNoteEdit).
     */
    export default Vue.extend({
        name: 'ReportWidgetResources',
        props: {
            scoreName: String,
        },
        computed: {
            canEdit () {
                return this.$user.practitionerId() != null && !this.$user.isMaskingPractitioner()
            },
            planResources () {
                return _.filter(this.$store.state.patientParticipant.plan.planResources, (pr) => {
                    return pr.resource_type == 'plan_of_care_option' && pr.resourceKeysList.indexOf(this.scoreName) != -1
                })
            },
            // planOptions format: {value: 'Physical Therapy', checked: false, resourceKeys: ['SCORE_EXER', ...]
            // (see SurveyNote::initPlanOptions)
            planOptions () {
                if (this.$store.state.draftSurveyNote.plan_options) {
                    return _.filter(this.$store.state.draftSurveyNote.plan_options, (po) => {
                        return po.resourceKeys.indexOf(this.scoreName) != -1
                    })
                } else {
                    return []
                }
            },
        },
    })
</script>

<style lang="scss">
</style>
